import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiCopy, FiAlertTriangle, FiArrowLeft, FiCheckCircle } from 'react-icons/fi';

function DropboxCallback() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    console.log('Authorization code copied to clipboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl p-8 border border-gray-100"
      >
        {code ? (
          <>
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FiCheckCircle className="h-8 w-8 text-green-600" />
              </div>
              <h1 className="text-2xl font-bold text-gray-900 mb-2">Authorization Successful</h1>
              <p className="text-gray-600">
                Your Dropbox authorization code has been generated successfully.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-4 mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Authorization Code
              </label>
              <div className="flex items-center space-x-2">
                <input
                  readOnly
                  value={code}
                  className="flex-1 p-3 font-mono text-sm bg-white border border-gray-300 rounded-lg focus:outline-none"
                />
                <button 
                  onClick={handleCopy} 
                  className="btn-secondary"
                >
                  <FiCopy className="h-4 w-4" />
                </button>
              </div>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-6">
              <h3 className="font-semibold text-yellow-800 mb-2">Next Steps:</h3>
              <ol className="text-sm text-yellow-700 space-y-1 list-decimal list-inside">
                <li>Copy the authorization code above</li>
                <li>Use it to generate your refresh token via API</li>
                <li>Add the refresh token to your environment variables</li>
                <li>Configure your Dropbox integration in the project</li>
              </ol>
            </div>
          </>
        ) : (
          <div className="text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiAlertTriangle className="h-8 w-8 text-red-600" />
            </div>
            <h1 className="text-2xl font-bold text-red-800 mb-2">Authorization Failed</h1>
            <p className="text-gray-600 mb-4">
              No authorization code was found. Please try the authorization process again.
            </p>
          </div>
        )}

        <div className="text-center">
          <button
            onClick={() => navigate('/setup-guides')}
            className="btn-secondary"
          >
            <FiArrowLeft className="mr-2 h-4 w-4" />
            Back to Setup Guides
          </button>
        </div>
      </motion.div>
    </div>
  );
}

export default DropboxCallback;